import { createSlice } from "@reduxjs/toolkit";

// Load cart from localStorage if available
const loadCartFromStorage = () => {
  try {
    const storedCart = localStorage.getItem("cart");
    return storedCart ? JSON.parse(storedCart) : [];
  } catch (error) {
    console.error("Error loading cart from localStorage:", error);
    return []; // Fallback to an empty array
  }
};

const initialState = {
  cart: loadCartFromStorage(),
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const item = action.payload;

      if (!item || !item.ID) {
        console.error("Invalid item in addToCart:", item);
        return;
      }

      const itemPresent = state.cart.find((cartItem) => cartItem.ID === item.ID);

      if (itemPresent) {
        state.cart = state.cart.map((cartItem) =>
          cartItem.ID === item.ID
            ? { ...cartItem, quantity: cartItem.quantity + 1 }
            : cartItem
        );
      } else {
        state.cart.push({ ...item, quantity: 1 });
      }

      localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    removeFromCart: (state, action) => {
      console.log("removeFromCart payload:", action.payload);
      console.log("Current cart:", state.cart);

      if (!action.payload || !action.payload.ID) {
        console.error("Invalid payload in removeFromCart:", action.payload);
        return;
      }

      state.cart = state.cart.filter((item) => item.ID !== action.payload.ID);
      localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    incrementQuantity: (state, action) => {
      const item = action.payload;

      if (!item || !item.ID) {
        console.error("Invalid item in incrementQuantity:", item);
        return;
      }

      state.cart = state.cart.map((cartItem) =>
        cartItem.ID === item.ID
          ? { ...cartItem, quantity: cartItem.quantity + 1 }
          : cartItem
      );

      localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    decrementQuantity: (state, action) => {
      const item = action.payload;

      if (!item || !item.ID) {
        console.error("Invalid item in decrementQuantity:", item);
        return;
      }

      state.cart = state.cart
        .map((cartItem) =>
          cartItem.ID === item.ID
            ? { ...cartItem, quantity: cartItem.quantity - 1 }
            : cartItem
        )
        .filter((cartItem) => cartItem.quantity > 0);

      localStorage.setItem("cart", JSON.stringify(state.cart));
    },

    clearCart: (state) => {
      state.cart = []; // Reset the cart to an empty array
      localStorage.removeItem("cart"); // Clear the cart from local storage
    },
  },
});

export const { addToCart, removeFromCart, incrementQuantity, decrementQuantity, clearCart } =
  cartSlice.actions;

export default cartSlice.reducer;